<template>
  <div>
    <section-title class="mt-3" content="Datos de Escuela" has-line />

    <div class="row my-3">
      <info-field
        class="col-3"
        label="Escuela/Institución Actual:"
        :value="model.studentDetail?.mipeStudent?.school"
      />
      <info-field
        class="col-3"
        label="Grado:"
        :value="model.studentDetail?.mipeStudent?.grade"
      />
      <info-field
        class="col-3"
        label="Alternativa de Ubicación:"
        :value="model.alternativeLocation"
      />
      <info-field class="col-3" label="Enfoque:" :value="model.focusType" />
    </div>

    <div class="row my-3">
      <info-field
        class="col-3"
        label="Región:"
        :value="model.studentDetail?.mipeStudent?.schoolRegion"
      />
      <info-field
        class="col-3"
        label="Municipio:"
        :value="model.studentDetail?.mipeStudent?.schoolMunicipality"
      />
      <info-field
        class="col-3"
        label="Diploma que Recibe:"
        :value="model.schoolDiploma"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/shared/components/SectionTitle.vue';
import InfoField from './InfoField.vue';

export default {
  name: 'SchoolInfoSection',
  components: {
    SectionTitle,
    InfoField,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
